<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="header-left">
    <div
      class="logo-wrapper"
      :title="$t('Botanical garden of the Charles University Science Faculty')"
    >
      <router-link :title="$t('Return to home')" to="/">
        <Logo class="logo"></Logo>
      </router-link>
    </div>
    <div class="menu-group">
      <div class="top-line">
        {{ $t("Botanical garden of the Charles University Science Faculty") }}
      </div>
      <div class="bottom-left-menu">
        <router-link
          :key="`menu_item_${idx}`"
          v-for="(item, idx) in topLeftMenuItems"
          :to="item.to"
        >
          <div class="bottom-left-menu-item">
            <span>{{ $t(item.label) }}</span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "@images/logo_icon.svg";
import { TopLeftMenuItems } from "@/services/menu";

export default {
  components: {
    Logo
  },
  computed: {
    topLeftMenuItems() {
      return TopLeftMenuItems;
    }
  }
};
</script>
<style lang="scss">
@import "./../page-header-unscoped";
</style>
